const Cube = () => (
  <div class="rubiks-container">
    <div class="rubiks-cube">
      <div class="top-clone">
        <div class="column-face top clone-left">
          <div class="left-one"></div>
          <div class="left-two"></div>
          <div class="left-three"></div>
        </div>
        <div class="column-face top clone-middle">
          <div class="middle-one"></div>
          <div class="middle-two"></div>
          <div class="middle-three"></div>
        </div>
        <div class="column-face top clone-right">
          <div class="right-one"></div>
          <div class="right-two"></div>
          <div class="right-three"></div>
        </div>
      </div>
      <div class="top-row">
        <div class="row-face front">
          <div class="front-one"></div>
          <div class="front-two"></div>
          <div class="front-three"></div>
        </div>
        <div class="row-face left">
          <div class="left-one"></div>
          <div class="left-two"></div>
          <div class="left-three"></div>
        </div>
        <div class="row-face back">
          <div class="back-one"></div>
          <div class="back-two"></div>
          <div class="back-three"></div>
        </div>
        <div class="row-face right">
          <div class="right-one"></div>
          <div class="right-two"></div>
          <div class="right-three"></div>
        </div>
      </div>
      <div class="middle-row">
        <div class="row-face front">
          <div class="front-one"></div>
          <div class="front-two"></div>
          <div class="front-three"></div>
        </div>
        <div class="row-face left">
          <div class="left-one"></div>
          <div class="left-two"></div>
          <div class="left-three"></div>
        </div>
        <div class="row-face back">
          <div class="back-one"></div>
          <div class="back-two"></div>
          <div class="back-three"></div>
        </div>
        <div class="row-face right">
          <div class="right-one"></div>
          <div class="right-two"></div>
          <div class="right-three"></div>
        </div>
      </div>
      <div class="bottom-row">
        <div class="row-face right">
          <div class="right-one"></div>
          <div class="right-two"></div>
          <div class="right-three"></div>
        </div>
        <div class="row-face left">
          <div class="left-one"></div>
          <div class="left-two"></div>
          <div class="left-three"></div>
        </div>
      </div>
      <div class="left-column">
        <div class="column-face front">
          <div class="front-one"></div>
          <div class="front-two"></div>
          <div class="front-three"></div>
        </div>
        <div class="column-face back">
          <div class="back-one"></div>
          <div class="back-two"></div>
          <div class="back-three"></div>
        </div>
        <div class="column-face bottom">
          <div class="bottom-one"></div>
          <div class="bottom-two"></div>
          <div class="bottom-three"></div>
        </div>
      </div>
      <div class="middle-column">
        <div class="column-face front">
          <div class="front-one"></div>
          <div class="front-two"></div>
          <div class="front-three"></div>
        </div>
        <div class="column-face top">
          <div class="top-one"></div>
          <div class="top-two"></div>
          <div class="top-three"></div>
        </div>
        <div class="column-face back">
          <div class="back-one"></div>
          <div class="back-two"></div>
          <div class="back-three"></div>
        </div>
        <div class="column-face bottom">
          <div class="bottom-one"></div>
          <div class="bottom-two"></div>
          <div class="bottom-three"></div>
        </div>
      </div>
      <div class="right-column">
        <div class="column-face front">
          <div class="front-one"></div>
          <div class="front-two"></div>
          <div class="front-three"></div>
        </div>
        <div class="column-face back">
          <div class="back-one"></div>
          <div class="back-two"></div>
          <div class="back-three"></div>
        </div>
        <div class="column-face bottom">
          <div class="bottom-one"></div>
          <div class="bottom-two"></div>
          <div class="bottom-three"></div>
        </div>
      </div>
    </div>
  </div>
);

export default Cube;
